import React from 'react'

import ContentBox from '../../subcomponents/ContentBox'

const OfferStandard = ({campaign, partnerLogo, logoFilter}) => (
    <div className={'mam3-type offer-standard ' + (!partnerLogo ? ' no-logo' : '')}>
        <ContentBox campaign={campaign} logo={logoFilter.includes('Web Logo verbergen') ? '' : partnerLogo}>
            {`__${campaign.label_teaser_topic}__\n`}
            {`${campaign.title_3_long}\n`}
            {`__${campaign.main_benefit_components_web}__`}
        </ContentBox>
    </div>
)

export default OfferStandard



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferStandard.js